const articleStore = {
  namespaced: true,
  state: {

  },
  mutations: {

  },
  actions: {

  },
  getters: {
  }
}
export default articleStore